import {
  type ChangePasswordRequest,
  type MeProfile,
  MeProfileSchema,
  type UpdateMeRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * /me API client (ADR-0040). Responses are Zod-validated so server
 * drift surfaces at the network boundary, not at render time.
 */

export const getProfile = async (): Promise<MeProfile> => {
  const { data } = await apiClient.get<unknown>('/me');
  return MeProfileSchema.parse(data);
};

export const updateProfile = async (payload: UpdateMeRequest): Promise<MeProfile> => {
  const { data } = await apiClient.patch<unknown>('/me', payload);
  return MeProfileSchema.parse(data);
};

export const changePassword = async (payload: ChangePasswordRequest): Promise<void> => {
  await apiClient.post('/me/change-password', payload);
};
